import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";
const PreliminaryIcon = (props) => {
  const { getThemeColorForTab } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3335 0.583496H8.16683L12.2502 4.66683V11.6668C12.2502 12.4032 11.6532 13.0002 10.9168 13.0002H2.3335C1.59708 13.0002 1.00016 12.4032 1.00016 11.6668V1.91683C1.00016 1.18041 1.59708 0.583496 2.3335 0.583496ZM10.9168 11.6668V5.25016H7.5835V1.91683H2.3335V11.6668H10.9168ZM3.50016 7.00016H7.00016V8.16683H3.50016V7.00016ZM3.50016 9.3335H8.16683V10.5002H3.50016V9.3335ZM9.3335 3.79183L10.5002 4.9585L8.05016 7.4085L6.8835 6.24183L9.3335 3.79183Z"
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default PreliminaryIcon;
